<div class="no-pet-page">
  <div class="no-pet-card" role="region" aria-label="No pets found">
    <div class="no-pet-copy">
      <h2 class="no-pet-title"><strong>You need a pet to use Petszel</strong></h2>

      <p class="no-pet-text">
        Access to Petszel requires at least one active pet profile. If you feel you've been
        redirected here by mistake, please <a routerLink="/">login</a> or contact
        <a href="mailto:support@petszel.com">support&#64;petszel.com</a>.
      </p>

      <a routerLink="/" class="submit">Login</a>
    </div>
  </div>
  <div class="padding-petszel-logo-reset">
    <img
      class="logo"
      src="../../assets/new-images/petszel-logo-vertical.svg"
      alt="Petszel"
    />
  </div>
</div>
